import { CopyButton, Text, Tooltip } from "@mantine/core";
import { useFlowStore } from "../../../../../../stores/WorkflowStore";
import { IconCheck } from "@tabler/icons-react";
import { useLanguage } from "../../../../../../stores/LanguageStore";

const NodeId = ({ id }) => {
  const lang = useLanguage((s) => s.language);
  const linking = useFlowStore((s) => s.linking);

  return (
    <CopyButton value={id}>
      {({ copied, copy }) => (
        <Tooltip
          label={copied ? lang.global.copied : `${lang.global.copy} #${id}`}
          color={copied ? "green" : "black"}
        >
          <Text
            pos={"absolute"}
            top={8}
            right={"105%"}
            size={linking?.id === id ? "lg" : "sm"}
            opacity={linking?.id === id ? 1 : 0.3}
            onClick={(e) => {
              e.stopPropagation();
              copy();
            }}
          >
            {copied ? <IconCheck size={16} /> : <>#{id}</>}
          </Text>
        </Tooltip>
      )}
    </CopyButton>
  );
};

export default NodeId;
